/* DESIGNSPOT 10/2026: na mobilu odkaz „Zobrazit vše“ pod obsahem sekce (kopie odkazu z hlavičky) */
(function(){
  function run(){
    document.querySelectorAll('.ds-sh .ds-sh__link, .ds-sh--blog .section-header__link').forEach(function(a){
      if(a.dataset.dsMore) return;
      var box=a.closest('.ds-empty__sec, .ds-reviews__panel, .blog-section, .index-section, .featured-collection, .shopify-section');
      if(!box) return;
      a.dataset.dsMore='1';
      var w=document.createElement('div'); w.className='ds-sh-more';
      var c=document.createElement('a'); c.href=a.getAttribute('href'); c.className='ds-sh-more__link';
      var t=document.createElement('span'); t.className='ds-sh-more__t'; t.textContent=a.textContent.trim(); c.appendChild(t);
      c.insertAdjacentHTML('beforeend','<svg class="ds-sh-more__ar" viewBox="0 0 6 10" aria-hidden="true"><path d="M1 1l4 4-4 4" fill="none" stroke="currentColor" stroke-width="1.2"/></svg>');
      w.appendChild(c); box.appendChild(w);
    });
  }
  if(document.readyState!=='loading') run(); else document.addEventListener('DOMContentLoaded',run);
  new MutationObserver(function(){ run(); }).observe(document.documentElement,{childList:true,subtree:true});
})();
